import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'

import i18n from './i18n'
import store from './store'
import EelementUi from 'element-ui'
import VueFilters from 'vue2-filters'
import VueMoment from 'vue-moment'
import IMask from 'imask'
import * as VueGoogleMaps from 'vue2-google-maps'
import * as filters from './filters' // global filters
import visibility from 'vue-visibility-change'
import Hotjar from 'vue-hotjar'
import 'element-ui/lib/theme-chalk/index.css'
import 'leaflet/dist/leaflet.css'
import './assets/style/index.scss'
import './assets/style/animate.min.css'
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'

const HOTJAR_ID = '2888521'

Vue.use(visibility)
Vue.use(EelementUi)
Vue.use(VueFilters)
Vue.use(VueMoment)
Vue.directive('mask', {
  bind: function(el, binding) {
    var inputs = el.getElementsByTagName('INPUT')
    var input = inputs[0]
    if (inputs.length > 1) {
      var i = 0
      var end = false
      while (i < inputs.length || !end) {
        if (inputs[i].type === 'text') {
          input = inputs[i]
          end = true
        }
        i++
      }
    }
    new IMask(
      input, {
        mask: binding.value
      })
  }
})

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GMAPS_KEY,
    libraries: 'drawing,visualization'
  }
})

Vue.component('l-map', LMap)
Vue.component('l-tile-layer', LTileLayer)
Vue.component('l-marker', LMarker)

if (process.env.NODE_ENV === 'production') {
  Vue.use(Hotjar, {
    id: HOTJAR_ID // Hotjar Site ID
  })
}

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

store.dispatch('start')

new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')
